import React from 'react';
import { Offerta } from '../types';

interface OfferStatusBadgeProps {
  stato: Offerta['stato'];
  commerciale?: string;
}

const COLORS: Record<Offerta['stato'], string> = {
  bozza: 'bg-gray-100 text-gray-800',
  inviata: 'bg-blue-100 text-blue-800',
  accettata: 'bg-green-100 text-green-800',
  rifiutata: 'bg-red-100 text-red-800',
  scaduta: 'bg-yellow-100 text-yellow-800',
};

const LABELS: Record<string, string> = { validata: 'Validata', in_validazione: 'In validazione', sconti_da_validare: 'Sconti da validare' };
const OfferStatusBadge: React.FC<OfferStatusBadgeProps> = ({ stato, commerciale }) => (
  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${commerciale === 'validata' ? COLORS.accettata : commerciale === 'in_validazione' || commerciale === 'sconti_da_validare' ? COLORS.scaduta : COLORS[stato]}`}>
    {commerciale && LABELS[commerciale] || stato.charAt(0).toUpperCase() + stato.slice(1)}
  </span>
);

export default OfferStatusBadge;
